import * as React from 'react';
import { SearchBox } from '@fluentui/react';
import useDebouncedState from 'hooks/useDebouncedState';

interface DebouncedSearchBoxProps {
    placeholder?: string;
    onChange(newValue: string): void;
}

export const DebouncedSearchBox: React.FC<DebouncedSearchBoxProps> = ({ placeholder = 'Suche...', onChange }) => {
    const [value, debouncedValue, setValue] = useDebouncedState<string>('');

    React.useEffect(() => {
        onChange(debouncedValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue]);

    return (
        <SearchBox
            value={value}
            onChange={(event, newValue): void => setValue(newValue === undefined ? '' : newValue)}
            placeholder={placeholder}
        />
    );
};
